module.exports = __webpack_public_path__ + "img/aboutUS_.f60b34c6.svg";